(function() {
    'use strict';

    angular.module("imApp").factory("invoicedStatusService", [function() {
        var service = {

        }

        return service;
    }]);
})();
